import { ipToInt } from './ipToInt'

/**
 * Check if an IPv4 address falls within a CIDR range.
 *
 * @param ip - The IPv4 address to check (e.g. '192.168.1.5')
 * @param cidr - The CIDR range (e.g. '192.168.1.0/24')
 * @returns True if the IP is within the CIDR range
 */
export const isIPInCIDR = (ip: string, cidr: string): boolean => {
    const [rangeIP, bits] = cidr.split('/')
    const mask = ~(2 ** (32 - parseInt(bits, 10)) - 1) >>> 0
    return (ipToInt(ip) & mask) === (ipToInt(rangeIP) & mask)
}
